import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  programItemWrapper: {
    ...theme.mixins.appClickableContainer,
    ...theme.mixins.appContainersSpacing,
  },

  programItemHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    width: '100%',
    minWidth: 0,
  },

  programItemTextColumn: {
    flex: 1,
    minWidth: 0,
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
  },

  programName: {
    fontWeight: 700,
    fontSize: 14,
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  programCollectionLine: {
    alignSelf: 'flex-start',
    maxWidth: '100%',
    whiteSpace: 'normal',
    overflowWrap: 'anywhere',
    wordBreak: 'break-word',
  },

  buttonsPanel: {
    display: 'flex',
    gap: theme.spacing(1),
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    flexShrink: 0,
  },
}));
